import React, { useEffect, useState } from "react";
import { writeFile, utils } from "xlsx";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardHeader from "@material-ui/core/CardHeader";
import Container from "@material-ui/core/Container";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Pagination from "@material-ui/lab/Pagination";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";

// core components
import Header from "../../components/Headers/Header.js";

import componentStyles from "../../assets/theme/views/admin/tables.js";
import { withAppContext } from "../../contextApi/Auth/index.js";

import axios from "axios";
import "sweetalert2/src/sweetalert2.scss";
import { BACKEND_URL } from "../../env.js";
import { Input } from "antd";
import { CardContent, Grid, Typography } from "@material-ui/core";

const useStyles = makeStyles(componentStyles);

const SubAdminOrder = () => {
    console.log("SubAdminOrder");

    const classes = useStyles();
    const [AllOrder, setAllOrder] = useState([]);
    const [FilteredOrders, setFilteredOrders] = useState([]);
    const [statusOptions] = useState([
        "pending",
        "shipped",
        "delivered",
        "cancelled",
    ]);
    const [payemntStatusOptions] = useState(["pending", "payed", "returned"]);
    const [openModal, setOpenModal] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [openIdModal, setOpenIdModal] = useState(false);
    const [openModalName, setOpenModalName] = useState(null);
    const [openProfiteModal, setOpenProfiteModal] = useState(false);
    const [editTracking, setEditTracking] = useState(null);
    const [productCost, setProductCost] = useState("");
    const [fromDate, setFromDate] = useState(""); // For "From Date"
    const [toDate, setToDate] = useState(""); // For "To Date"
    const [number, setNumber] = useState("");
    const [email, setEmail] = useState("");
    const [pageNo, setPageNo] = useState(1);
    const [totalOrders, setTotalOrders] = useState(0);
    const [profitMargin, setProfitMargin] = useState("");
    const [editMargin, setEditMargin] = useState(null);
    const [pending, setPending] = useState(0);
    const [pendingPayment, setPendingPayment] = useState(0);
    const [delivered, setDelivered] = useState(0);
    const [deliveredPayment, setDeliveredPayment] = useState(0);
    const [cancel, setCancelled] = useState(0);
    const [cancelPayment, setCancelledPayment] = useState(0);
    const [shiped, setShiped] = useState(0);
    const [shipedPayment, setShipedPayment] = useState(0);
    const [paid, setPaid] = useState(0);
    const [paidPayment, setPaidPayment] = useState(0);
    const [unpaid, setUnpaid] = useState(0);
    const [unpaidPayment, setUnpaidPayment] = useState(0);
    const [returns, setReturn] = useState(0);
    const [productCharges, setProductCharges] = useState(0);
    const [productCount, setProductCount] = useState(0);
    const [desertsCost, setDesertsCost] = useState(0);
    const [desertsCount, setDesertsCount] = useState(0);
    const [sifzCost, setSifzCost] = useState(0);
    const [sifzCount, setSifzCount] = useState(0);
    const [slipCost, setSlipCost] = useState(0);
    const [slipCount, setSlipCount] = useState(0);
    const [deliveryCost, setDeliveryCost] = useState(0);
    const [deliveryCount, setDeliveryCount] = useState(0);
    const [resellerCost, setResellerCost] = useState(0);
    const [resellerCount, setResellerCount] = useState(0);
    const [statusFilter, setStatusFilter] = useState(""); // new status filter

    const ordersPerPage = 20;
    const GetAllOrder = () => {
        axios
            .get(`${BACKEND_URL}/orders/SubAdminOrdersAnalytics`, {
                headers: {
                    token: localStorage.getItem("Token"),
                },
                params: {
                    startDate: fromDate, // ya dynamic value
                    endDate: toDate, // ya dynamic value
                    number: number,         // orderId ka part
                    status: statusFilter
                }
            })
            .then((res) => {
                console.log(res.data, "order");
                setAllOrder(res?.data?.orders);
                setPending(res?.data?.summary?.pending);
                setPendingPayment(res?.data?.summary?.pendingPayment);
                setDelivered(res?.data?.summary?.delivered);
                setDeliveredPayment(res?.data?.summary?.deliveredPayment);
                setCancelled(res?.data?.summary?.cancelled);
                setCancelledPayment(res?.data?.summary?.cancelledpayment);
                setShiped(res?.data?.summary?.shiped);
                setShipedPayment(res?.data?.summary?.shippedpayment);
                setPaid(res?.data?.summary?.PaidCount);
                setPaidPayment(res?.data?.summary?.paidpayment);
                setUnpaid(res?.data?.summary?.unpaidCount);
                setUnpaidPayment(res?.data?.summary?.unpaidpayment);
                setReturn(res?.data?.summary?.returnpayment);
                setProductCharges(res?.data?.summary?.productCharges);
                setProductCount(res?.data?.summary?.productChargesCount);
                setDeliveryCost(res?.data?.summary?.deliveryCharges);
                setDeliveryCount(res?.data?.summary?.deliveryChargesCount);
                setDesertsCost(res?.data?.summary?.desertsCost);
                setDesertsCount(res?.data?.summary?.desertsCostCount);
                setSifzCost(res?.data?.summary?.sifzCost);
                setSifzCount(res?.data?.summary?.sifzCostCount);
                setSlipCost(res?.data?.summary?.slipCost);
                setSlipCount(res?.data?.summary?.slipCostCount);
                setResellerCost(res?.data?.summary?.resellerAmount);
                setResellerCount(res?.data?.summary?.resellerCount);
                setFilteredOrders(res?.data?.orders);
            })
            .catch((err) => console.log(err));
    };
    useEffect(() => {
        GetAllOrder();
    }, [pageNo]);
    const handlePageChange = (event, value) => {
        setPageNo(value);
    };
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
    };

    const handleStatusChange = (orderId, newStatus) => {
        axios
            .put(
                `${BACKEND_URL}/orders/${orderId}`,
                { status: newStatus === "dispatch" ? "shipped" : newStatus },
                {
                    headers: {
                        token: localStorage.getItem("Token"),
                    },
                }
            )
            .then((res) => {
                GetAllOrder();
            })
            .catch((err) => console.log(err));
    };

    const handleViewProductClick = (products) => {
        console.log(products, "orderproduct");

        setSelectedProduct(products);
        setOpenModal(true);
    };
    const handleOpenProfiteModal = (id) => {
        console.log(id, "orderproduct");

        setEditMargin(id);
        setOpenProfiteModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        setSelectedProduct(null);
    };
    const handleIdCloseModal = () => {
        setOpenIdModal(false);
        setOpenModalName(null);
        setEditTracking(null);
        setProductCost("");
    };
    const handleProfiteCloseModal = () => {
        setOpenProfiteModal(false);
        setEditMargin(null);
        setProfitMargin("");
    };
    const handleSubmitId = () => {
        axios
            .put(
                `${BACKEND_URL}/orders/${editMargin}`,
                openModalName === "productCharges" ? { productCharges: productCost } : openModalName === "deliveryCharges" ? { deliveryCharges: productCost } : openModalName === "desertsCost" ? { desertsCost: productCost } : openModalName === "sifzCost" ? { sifzCost: productCost } : { slipCost: productCost },
                {
                    headers: {
                        token: localStorage.getItem("Token"),
                    },
                }
            )
            .then((res) => {
                GetAllOrder();
                handleIdCloseModal();
            })
            .catch((err) => console.log(err));
    };
    const handleForward = (ForwardID) => {
        axios
            .put(
                `${BACKEND_URL}/orders/${ForwardID}`,
                { view: "subadmin" },
                {
                    headers: {
                        token: localStorage.getItem("Token"),
                    },
                }
            )
            .then((res) => {
                GetAllOrder();
                handleIdCloseModal();
            })
            .catch((err) => console.log(err));
    };

    // Handle Date Filter
    const handleFilter = () => {
        // const from = new Date(fromDate).setHours(0, 0, 0, 0);
        // const to = new Date(toDate).setHours(23, 59, 59, 999);

        // const filtered = AllOrder.filter((order) => {
        //     const orderDate = new Date(order.orderDate).getTime();

        //     const isDateValid =
        //         (!fromDate || orderDate >= from) && (!toDate || orderDate <= to);
        //     const isNumberValid = !number || order.orderId?.includes(number);
        //     const isStatusValid = !statusFilter || order.status === statusFilter;

        //     return isDateValid && isNumberValid && isStatusValid;
        // });

        // setFilteredOrders(filtered);
        GetAllOrder()
    };

    const handleClearFilter = () => {
        // setFilteredOrders(AllOrder);
        setFromDate("");
        setToDate("");
        setNumber("");
        setStatusFilter("");
        GetAllOrder()
    };
    const handleDownloadExcel = () => {
        // Prepare the data for Excel
        const data = [];

        FilteredOrders.forEach((order) => {
            if (order.products && order.products.length > 0) {
                order.products.forEach((product) => {
                    data.push({
                        "Order ID": order.orderId,
                        "Order Date": formatDate(order.orderDate),
                        StoreName: order.user.storeName,
                        Email: order.email,
                        "Phone Number": order.phoneNumber,
                        "Product ID": product.id,
                        "Product Name": product.title,
                        "Product Quantity": product.orderproduct.quantity,
                        "Product Price": product.price,
                        "Total Amount": order.totalAmount,
                        City: order.city,
                        Name: `${order?.firstName} ${order?.lastName}`,
                        address: `${order?.address1}`,
                    });
                });
            } else {
                data.push({
                    "Order ID": order.orderId,
                    "Order Date": formatDate(order.orderDate),
                    StoreName: order.user.storeName,
                    Email: order.email,
                    "Phone Number": order.phoneNumber,
                    "Profit Margin": order.profileMargin || 0,
                    City: order.city,
                    "Total Amount": order.totalAmount,
                });
            }
        });

        // Create a worksheet and workbook
        const worksheet = utils.json_to_sheet(data);
        const workbook = utils.book_new();
        utils.book_append_sheet(workbook, worksheet, "Orders");

        const from = fromDate ? formatDate(fromDate) : "Start";
        const to = toDate ? formatDate(toDate) : "End";
        const fileName = `Orders_${from}_to_${to}.xlsx`;

        // Trigger download
        writeFile(workbook, fileName);
    };
    const handleOpenIdModal = (id, name) => {
        console.log(id, "orderproduct");

        setEditMargin(id);
        setOpenIdModal(true);
        setOpenModalName(name);
    };
    const handleSubmitProfite = () => {
        axios
            .put(
                `${BACKEND_URL}/orders/${editMargin}`,
                { profileMargin: profitMargin },
                {
                    headers: {
                        token: localStorage.getItem("Token"),
                    },
                }
            )
            .then((res) => {
                // if(res?.id){
                // window.location.reload()
                // }
                GetAllOrder();
                setOpenProfiteModal(false);
                setEditMargin(false);
            })
            .catch((err) => console.log(err));
    };
    const handleProfiteStatusChange = (orderId, newStatus) => {
        axios
            .put(
                `${BACKEND_URL}/orders/${orderId}`,
                { transactionStatus: newStatus },
                {
                    headers: {
                        token: localStorage.getItem("Token"),
                    },
                }
            )
            .then((res) => {
                GetAllOrder();
            })
            .catch((err) => console.log(err));
    };
    // const handleDownloadExcel = () => {
    //     // Prepare the data for Excel
    //     const data = FilteredOrders.map((order) => ({
    //         "Order ID": order.orderId,
    //         "Order Date": formatDate(order.orderDate),
    //         "Email": order.email,
    //         "Phone Number": order.phoneNumber,
    //         "Profit Margin": order.profitMargin || 0,
    //         "City": order.city,
    //         "Total Amount": order.totalAmount,
    //         "Products Count": order.products?.length || 0,
    //         "Status": order.status,
    //     }));

    //     // Create a worksheet and workbook
    //     const worksheet = utils.json_to_sheet(data);
    //     const workbook = utils.book_new();
    //     utils.book_append_sheet(workbook, worksheet, "Orders");

    //     // Trigger download
    //     writeFile(workbook, "FilteredOrders.xlsx");
    // };
    return (
        <>
            <Header />
            <Container
                maxWidth={false}
                component={Box}
                marginTop="-6rem"
                classes={{ root: classes.containerRoot }}
            >
                <Card
                    style={{ marginTop: "20px", marginBottom: "20px" }}
                    classes={{ root: classes.cardRoot }}
                >
                    <CardContent>
                        <Grid container spacing={2}>
                            {/* Order Status Filter */}
                            <Grid item xs={12} sm={4} md={3}>
                                <Select
                                    fullWidth
                                    displayEmpty
                                    value={statusFilter}
                                    onChange={(e) => setStatusFilter(e.target.value)}
                                    variant="outlined"
                                >
                                    <MenuItem value="">All Statuses</MenuItem>
                                    <MenuItem value="delivered">Delivered</MenuItem>
                                    <MenuItem value="cancelled">Return</MenuItem>
                                    <MenuItem value="shipped">Dispatch</MenuItem>
                                    <MenuItem value="pending">Pending</MenuItem>
                                </Select>
                            </Grid>

                            {/* Date From */}
                            <Grid item xs={12} sm={4} md={3}>
                                <TextField
                                    label="From Date"
                                    type="date"
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    value={fromDate}
                                    onChange={(e) => setFromDate(e.target.value)}
                                    variant="outlined"
                                />
                            </Grid>

                            {/* Date To */}
                            <Grid item xs={12} sm={4} md={3}>
                                <TextField
                                    label="To Date"
                                    type="date"
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    value={toDate}
                                    onChange={(e) => setToDate(e.target.value)}
                                    variant="outlined"
                                />
                            </Grid>

                            {/* Order ID Search */}
                            <Grid item xs={12} sm={6} md={3}>
                                <TextField
                                    fullWidth
                                    label="Search Order ID"
                                    value={number}
                                    onChange={(e) => setNumber(e.target.value)}
                                    variant="outlined"
                                />
                            </Grid>

                            {/* Buttons */}
                            <Grid item xs={12} sm={6} md={3}>
                                <Button
                                    fullWidth
                                    onClick={handleFilter}
                                    variant="contained"
                                    color="primary"
                                >
                                    Apply Filter
                                </Button>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <Button
                                    fullWidth
                                    onClick={handleClearFilter}
                                    variant="outlined"
                                    color="secondary"
                                >
                                    Clear Filter
                                </Button>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>

                <Grid container spacing={2}>
                    {/* {cardData.map(({ label, key }) => (
                                        <Grid item xs={12} sm={6} md={4} key={key}>
                                            <Card elevation={3}>
                                                <CardContent>
                                                    <Typography variant="subtitle1">{label}</Typography>
                                                    <Typography variant="h6" color="primary">
                                                        {(() => {
                                                            switch (key) {
                                                                case 'completed': return completed;
                                                                case 'cancelled': return cancelled;
                                                                case 'inProcess': return inProcess;
                                                                case 'PaymentPaid': return PaymentPaid;
                                                                case 'PaymentPending': return PaymentPending;
                                                                case 'PaymentReturn': return PaymentReturn;
                                                                case 'totalProfitMargin': return totalProfitMargin;
                                                                default: return 0;
                                                            }
                                                        })()}
                                                    </Typography>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    ))} */}
                    <Grid item xs={12} sm={6} md={4}>
                        <Card elevation={3}>
                            <CardContent>
                                <Typography variant="subtitle1">Order Delivered</Typography>
                                <Typography variant="h6" color="primary">
                                    AED {deliveredPayment}
                                </Typography>
                                <Typography variant="h6" color="primary">
                                    {delivered} (Order)
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Card elevation={3}>
                            <CardContent>
                                <Typography variant="subtitle1">Order Returned</Typography>
                                <Typography variant="h6" color="primary">
                                    AED -{cancel * 5}
                                </Typography>
                                <Typography variant="h6" color="primary">
                                    {cancel} (Order)
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Card elevation={3}>
                            <CardContent>
                                <Typography variant="subtitle1">Order Pending</Typography>
                                <Typography variant="h6" color="primary">
                                    AED {pendingPayment}
                                </Typography>
                                <Typography variant="h6" color="primary">
                                    {pending} (Order)
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Card elevation={3}>
                            <CardContent>
                                <Typography variant="subtitle1">Order Dispatch</Typography>
                                <Typography variant="h6" color="primary">
                                    AED {shipedPayment}
                                </Typography>
                                <Typography variant="h6" color="primary">
                                    {shiped} (Order)
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} >
                        <Card elevation={3}>
                            <CardContent>
                                <Typography variant="subtitle1">Deserts Profit</Typography>
                                <Typography variant="h6" color="primary">
                                    AED {desertsCost}
                                </Typography>
                                <Typography variant="h6" color="primary">
                                    {desertsCount} (Order)
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} >
                        <Card elevation={3}>
                            <CardContent>
                                <Typography variant="subtitle1">Sifz Profit</Typography>
                                <Typography variant="h6" color="primary">
                                    AED {sifzCost}
                                </Typography>
                                <Typography variant="h6" color="primary">
                                    {sifzCount} (Order)
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} >
                        <Card elevation={3}>
                            <CardContent>
                                <Typography variant="subtitle1">Slip Cost</Typography>
                                <Typography variant="h6" color="primary">
                                    AED {slipCost}
                                </Typography>
                                <Typography variant="h6" color="primary">
                                    {slipCount} (Order)
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} >
                        <Card elevation={3}>
                            <CardContent>
                                <Typography variant="subtitle1">Reseller Amount</Typography>
                                <Typography variant="h6" color="primary">
                                    AED {resellerCost}
                                </Typography>
                                <Typography variant="h6" color="primary">
                                    {resellerCount} (Order)
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <Card
                    style={{ marginTop: "20px" }}
                    classes={{ root: classes.cardRoot }}
                >
                    <CardHeader
                        className={classes.cardHeader}
                        title="Order Analytics"
                        titleTypographyProps={{
                            component: Box,
                            marginBottom: "0!important",
                            variant: "h3",
                        }}
                    />

                    {FilteredOrders && FilteredOrders?.length >= 1 ? (
                        <TableContainer>
                            <Box
                                component={Table}
                                alignItems="center"
                                marginBottom="0!important"
                            >
                                <TableHead>
                                    <TableRow>
                                        <TableCell
                                            className={
                                                classes.tableCellRoot + " " + classes.tableCellRootHead
                                            }
                                        >
                                            Order ID
                                        </TableCell>
                                        <TableCell
                                            className={
                                                classes.tableCellRoot + " " + classes.tableCellRootHead
                                            }
                                        >
                                            Order Date
                                        </TableCell>
                                        <TableCell
                                            className={
                                                classes.tableCellRoot + " " + classes.tableCellRootHead
                                            }
                                        >
                                            Status Update Date
                                        </TableCell>

                                        <TableCell
                                            className={
                                                classes.tableCellRoot + " " + classes.tableCellRootHead
                                            }
                                        >
                                            Product Name
                                        </TableCell>
                                        <TableCell
                                            className={
                                                classes.tableCellRoot + " " + classes.tableCellRootHead
                                            }
                                        >
                                            Total Amount
                                        </TableCell>
                                        <TableCell
                                            className={
                                                classes.tableCellRoot + " " + classes.tableCellRootHead
                                            }
                                        >
                                            Product Cost
                                        </TableCell>
                                        <TableCell
                                            className={
                                                classes.tableCellRoot + " " + classes.tableCellRootHead
                                            }
                                        >
                                            Add Product Cost
                                        </TableCell>
                                        <TableCell
                                            className={
                                                classes.tableCellRoot + " " + classes.tableCellRootHead
                                            }
                                        >
                                            Deserts Profit
                                        </TableCell>
                                        <TableCell
                                            className={
                                                classes.tableCellRoot + " " + classes.tableCellRootHead
                                            }
                                        >
                                            Add Deserts Profit
                                        </TableCell>
                                        <TableCell
                                            className={
                                                classes.tableCellRoot + " " + classes.tableCellRootHead
                                            }
                                        >
                                            Sifz Profit
                                        </TableCell>
                                        <TableCell
                                            className={
                                                classes.tableCellRoot + " " + classes.tableCellRootHead
                                            }
                                        >
                                            Add Sifz Profit
                                        </TableCell>
                                        <TableCell
                                            className={
                                                classes.tableCellRoot + " " + classes.tableCellRootHead
                                            }
                                        >
                                            Delivery Charges
                                        </TableCell>
                                        <TableCell
                                            className={
                                                classes.tableCellRoot + " " + classes.tableCellRootHead
                                            }
                                        >
                                            Add Delivery Charges
                                        </TableCell>
                                        <TableCell
                                            className={
                                                classes.tableCellRoot + " " + classes.tableCellRootHead
                                            }
                                        >
                                            Slip Cost
                                        </TableCell>
                                        <TableCell
                                            className={
                                                classes.tableCellRoot + " " + classes.tableCellRootHead
                                            }
                                        >
                                            Add Slip Cost
                                        </TableCell>
                                        <TableCell
                                            className={
                                                classes.tableCellRoot + " " + classes.tableCellRootHead
                                            }
                                        >
                                            Transaction Status
                                        </TableCell>
                                        <TableCell
                                            className={
                                                classes.tableCellRoot + " " + classes.tableCellRootHead
                                            }
                                        >
                                            Status
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {FilteredOrders.sort(
                                        (a, b) => new Date(b.orderDate) - new Date(a.orderDate)
                                    )?.map((order) => {
                                        console.log(order);

                                        return (
                                            <TableRow key={order.orderId}>
                                                <TableCell
                                                    className={
                                                        classes.tableCellRoot +
                                                        " " +
                                                        classes.tableCellRootBodyHead
                                                    }
                                                >
                                                    <Box alignItems="center" display="flex">
                                                        <Box display="flex" alignItems="flex-start">
                                                            <Box fontSize=".875rem" component="span">
                                                                {order.orderId}
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                </TableCell>
                                                <TableCell className={classes.tableCellRoot}>
                                                    <Box paddingTop=".35rem" paddingBottom=".35rem">
                                                        {formatDate(order?.orderDate)}
                                                    </Box>
                                                </TableCell>
                                                <TableCell className={classes.tableCellRoot}>
                                                    <Box paddingTop=".35rem" paddingBottom=".35rem">
                                                        {formatDate(order?.statusUpdateDate)}
                                                    </Box>
                                                </TableCell>

                                                <TableCell className={classes.tableCellRoot}>
                                                    <Box paddingTop=".35rem" paddingBottom=".35rem">
                                                        {order.products.length > 0 ? (
                                                            order.products.map((product, index) => (
                                                                <div key={index}>{product.title}</div>
                                                            ))
                                                        ) : (
                                                            // fallback to subadminProduct
                                                            JSON.parse(order.subadminProduct || "[]").map((item, index) => (
                                                                <div key={index}>{item.productId}</div>
                                                            ))
                                                        )}
                                                    </Box>
                                                </TableCell>
                                                <TableCell className={classes.tableCellRoot}>
                                                    <Box paddingTop=".35rem" paddingBottom=".35rem">
                                                        {order.totalAmount}
                                                    </Box>
                                                </TableCell>
                                                <TableCell className={classes.tableCellRoot}>
                                                    <Box paddingTop=".35rem" paddingBottom=".35rem">
                                                        {order?.productCharges || "-"}
                                                    </Box>
                                                </TableCell>
                                                <TableCell className={classes.tableCellRoot}>
                                                    <Box paddingTop=".35rem" paddingBottom=".35rem">
                                                        <Button onClick={() =>
                                                            handleOpenIdModal(order.id, "productCharges")

                                                        }>
                                                            Add Product Cost
                                                        </Button>
                                                    </Box>
                                                </TableCell>
                                                <TableCell className={classes.tableCellRoot}>
                                                    <Box paddingTop=".35rem" paddingBottom=".35rem">
                                                        {order?.desertsCost || "-"}
                                                    </Box>
                                                </TableCell>
                                                <TableCell className={classes.tableCellRoot}>
                                                    <Box paddingTop=".35rem" paddingBottom=".35rem">
                                                        <Button onClick={() => {
                                                            handleOpenIdModal(order.id, "desertsCost")
                                                        }}>
                                                            Add Deserts Profit
                                                        </Button>
                                                    </Box>
                                                </TableCell>
                                                <TableCell className={classes.tableCellRoot}>
                                                    <Box paddingTop=".35rem" paddingBottom=".35rem">
                                                        {order?.sifzCost || "-"}
                                                    </Box>
                                                </TableCell>
                                                <TableCell className={classes.tableCellRoot}>
                                                    <Box paddingTop=".35rem" paddingBottom=".35rem">
                                                        <Button onClick={() => handleOpenIdModal(order.id, "sifzCost")}>
                                                            Add Sifz Profit
                                                        </Button>
                                                    </Box>
                                                </TableCell>
                                                <TableCell className={classes.tableCellRoot}>
                                                    <Box paddingTop=".35rem" paddingBottom=".35rem">
                                                        {order?.deliveryCharges || "-"}
                                                    </Box>
                                                </TableCell>
                                                <TableCell className={classes.tableCellRoot}>
                                                    <Box paddingTop=".35rem" paddingBottom=".35rem">
                                                        <Button onClick={() => handleOpenIdModal(order.id, "deliveryCharges")}>
                                                            Add Delivery Charges
                                                        </Button>
                                                    </Box>
                                                </TableCell>
                                                <TableCell className={classes.tableCellRoot}>
                                                    <Box paddingTop=".35rem" paddingBottom=".35rem">
                                                        {order?.slipCost || "-"}
                                                    </Box>
                                                </TableCell>
                                                <TableCell className={classes.tableCellRoot}>
                                                    <Box paddingTop=".35rem" paddingBottom=".35rem">
                                                        <Button onClick={() => handleOpenIdModal(order.id, "slipCost")}>
                                                            Add Slip Cost
                                                        </Button>
                                                    </Box>
                                                </TableCell>
                                                <TableCell className={classes.tableCellRoot}>
                                                    <Box paddingTop=".35rem" paddingBottom=".35rem">
                                                        {order.transactionStatus === "pending"
                                                            ? "unpaid"
                                                            : order.transactionStatus === "payed"
                                                                ? "paid"
                                                                : order.transactionStatus}
                                                    </Box>
                                                    {/* <Select
                                                        value={order.transactionStatus}
                                                        onChange={(e) =>
                                                            handleProfiteStatusChange(
                                                                order.id,
                                                                e.target.value
                                                            )
                                                        }
                                                        variant="outlined"
                                                        fullWidth
                                                    >
                                                        {payemntStatusOptions.map((status) => (
                                                            <MenuItem key={status} value={status}>
                                                                {status === "pending"
                                                                    ? "unpaid"
                                                                    : status === "payed"
                                                                        ? "paid"
                                                                        : status}
                                                            </MenuItem>
                                                        ))}
                                                    </Select> */}
                                                </TableCell>
                                                <TableCell className={classes.tableCellRoot}>
                                                    <Box paddingTop=".35rem" paddingBottom=".35rem">
                                                        {order.status === "shipped"
                                                            ? "dispatch"
                                                            : order.status === "cancelled"
                                                                ? "return"
                                                                : order.status}
                                                    </Box>
                                                    {/* <Select
                                                        // value={status === "disptach" ? "shipped" : order.status}
                                                        value={order.status}
                                                        onChange={(e) =>
                                                            handleStatusChange(order.id, e.target.value)
                                                        }
                                                        variant="outlined"
                                                        fullWidth
                                                    >
                                                        {statusOptions.map((status) => (
                                                            <MenuItem key={status} value={status}>
                                                                {status === "shipped"
                                                                    ? "dispatch"
                                                                    : status === "cancelled"
                                                                        ? "return"
                                                                        : status}
                                                            </MenuItem>
                                                        ))}
                                                    </Select> */}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Box>
                        </TableContainer>
                    ) : (
                        <div
                            style={{
                                width: "100%",
                                display: "flex",
                                alignContent: "center",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <h1>No Order to Show</h1>
                        </div>
                    )}
                    <Box
                        classes={{ root: classes.cardActionsRoot }}
                        component={CardActions}
                        justifyContent="flex-end"
                    >
                        <Pagination
                            count={Math.ceil(totalOrders / ordersPerPage)}
                            page={pageNo}
                            onChange={handlePageChange}
                            color="primary"
                            variant="outlined"
                        />
                    </Box>
                </Card>

                {/* Modal for viewing products */}
                <Dialog
                    open={openIdModal}
                    onClose={handleIdCloseModal}
                    maxWidth="xs"
                    fullWidth
                >
                    <DialogTitle>{openModalName === "productCharges" ? "Product Cost" : openModalName === "deliveryCharges" ? "Delivery Charges" : openModalName === "desertsCost" ? "Deserts Cost" : openModalName === "sifzCost" ? "Sifz Cost" : "Slip Cost"}</DialogTitle>
                    <DialogContent>
                        <Input
                            placeholder="Product Cost"
                            value={productCost}
                            onChange={(e) => setProductCost(e.target.value)}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleIdCloseModal} color="primary">
                            Close
                        </Button>
                        <Button onClick={handleSubmitId} color="success">
                            Submit
                        </Button>
                    </DialogActions>
                </Dialog>
            </Container>
        </>
    );
};

export default withAppContext(SubAdminOrder);
